import 'whatwg-fetch';

import type { Credentials } from '../types';

import { apiUrl, fetchRequest, settingApi } from './index';

export type AuthTokenResponse = {
  accessToken: string;
};

export const login = async (
  credentials: Credentials
): Promise<AuthTokenResponse> => {
  const response = await window.fetch(`${apiUrl}/auth/token`, {
    method: 'POST',
    body: JSON.stringify(credentials),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  if (response.ok) {
    return (await response.json()) as AuthTokenResponse;
  } else {
    if (response.status === 400 || response.status === 401) {
      throw new Error('Invalid credentials');
    } else {
      throw new Error('Server error');
    }
  }
};

export const getWialonToken = async (): Promise<string> => {
  const { value } = await settingApi.fetch({ settingKey: 'WialonApiToken' });
  if (value) return value;
  throw new Error('Не удалось получить токен из Виалона');
};

export const getEmployeeToken = async (
  employeeId: number
): Promise<AuthTokenResponse> => {
  const token = await fetchRequest.post(`/auth/employeeToken/${employeeId}`);
  if (token) {
    return token;
  }
  throw new Error('Не удалось запросить токен для пользователя');
};

export default { login, getWialonToken, getEmployeeToken };
